module.exports = __webpack_public_path__ + "img/datakairos_logo_seul.9c91cc34.svg";